import { widgetWrapper } from '../worker/widgetWrapper';
import { Component } from './mobile.component';
import { createStore } from './mobile.store';

export const MobileWidgetComponent = widgetWrapper({
  createStore,
  Component,
});
